<template lang="pug">
  title-tab(:msg="$t('title.contact-agent')")
    v-row(no-gutters)
      v-col.pt-3.px-1(
        cols='12', md='4'
      )
        v-card.pa-3(
          v-if='agentInfo'
          height='100%'
          flat
        )
          li(
            v-if='agentInfo.link_url'
          )
            v-icon.mr-2 mdi-link
            a.text--black(
              :href='agentInfo.link_url'
            ) {{ agentInfo.link_url }}
          li(
            v-if='agentInfo.email'
          )
            v-icon.mr-3 mdi-account-box
            span.text--black {{ agentInfo.email }}
          li(v-if='agentInfo.line_id')
            v-icon.mr-3 fab fa-line
            a.text--black(
              :href="'http://line.me/ti/p/~'+agentInfo.line_id"
            ) {{ agentInfo.line_id }}
          li(v-if='agentInfo.public_phone')
            v-icon.mr-3 mdi-phone
            a.text--black(
              :href="'tel:'+agentInfo.public_phone"
            ) {{ agentInfo.public_phone }}
          v-divider.my-5
          div(
            v-html='agentInfo.description'
          )
      v-col.pt-3.px-1(
        cols='12'
        md='8'
      )
        v-card.pa-3(flat)
          v-card.overflow-y-auto.pa-2.my-3(
            v-if='items.length!==0'
            v-chat-scroll='{ always: false , smooth: true }'
            outlined
            max-height='250'
            @v-chat-scroll-top-reached='load'
          )
            template(
              v-for='(item,i) in items'
            )
              v-row(
                no-gutters
                :key='i'
                :justify="item.created_by_user.username === userProfile.username ? 'end':'start'" 
              ).pt-1
                v-card.px-3(
                  flat
                  :max-width="item.created_by_user.username === userProfile.username ? '40%' : '80%'"
                  :color="item.created_by_user.username === userProfile.username ?\
                  'var(--bg-home)':\
                  'var(--bg-secondary-color)'"
                  :dark='item.created_by_user.username !== userProfile.username'
                )
                  v-row(
                    no-gutters
                    :justify="item.created_by_user.username === userProfile.username ? 'end' : 'start' " 
                  )
                    b(
                      v-if='item.created_by_user.username === userProfile.username'
                    ) {{ $t('you') }}
                    b(
                      v-else
                    ) {{ item.created_by_user.username }}
                  p(v-html="formattedContent(item.text)")
          v-form(
            ref='form'
            @submit.prevent
          )
            v-text-field(
              v-model='message'
              dense
              required
              outlined
              :rules='messageRules'
              :label="$t('label.message')"
            )
            n-btn-submit(  
              :loading='submitStatus'
              color='blue' 
              @click='submit'
            ) {{ $t('button.send-chat') }}

</template>
<script> 
import { chat as apiChat , agentInfo as apiAgentInfo } from '@/apis'     
import Validations from '@/mixins/Validations'
import * as c from '@/const/setTimeOutConfig'
import { ROUTE_CONTACT } from '@/const/route'
export default {
  mixins: [Validations],
  data: () => ({   
    items:[], 
    agentInfo:false,
    message: null,
    page : 1, 
    submitStatus : false 
  }), 
  computed: {   
    userProfile () {
      return this.$store.getters['userProfile/GETTERS_ME']
    },
  },
  async created () {
    await this.getAgentInfo()
    await this.getChatApi()
    this.countDown()
  },   
  methods: {  
    async getAgentInfo (){
      const [err,data ] = await apiAgentInfo.get()
      
      if(err) {
        return
      }     

      this.agentInfo = data 
    },

    load () {  
      if(this.items.length>=15){  
        this.page += 1
        this.getChatApi (true)
      } 
    },

    formattedContent (text) {
      const urlPattern = /https?:\/\/[^\s]+/g;
      const formattedText = text.replace(urlPattern, (url) => {
        return `<a href="${url}" target="_blank">${url}</a>`;
      });
      return formattedText;
    },

    countDown () {
      var TimeLoop = setTimeout(()=>{ 
        if(this.$route.name === ROUTE_CONTACT) { 
          this.getChatApi()
          this.countDown ()
        } else {
          clearTimeout(TimeLoop)
        }
      },c.CONTACTAGENT) 
    },
    manageChat (dataArray=[]) { 
      var result = []
        dataArray.forEach(x=>{ 
        if(!this.items.find(y=>y.uuid===x.uuid)){
          result.push(x)
        }
      })
      return result
    },
    async getChatApi (load=false) {
      this.page = load ? this.page : 1 

      const params = {
        page : this.page
      }

      const [err,data ] = await apiChat.get(params)
      
      if(err) {
        this.$alert('',err,'warning') 
        return
      }     
 
      let chatArray = this.items.concat(this.manageChat(data)) 
      this.items = chatArray.sort((a, b)=>{
        if (a.created_at < b.created_at)
          return -1;
        if (a.created_at > b.created_at)
          return 1;
        return 0;
      }) 
    },
    async submit () {  
      this.$ga.event('Submit', 'SendChat', 'ContactAgentPage','' )   
      let data = {
        text : this.message
      } 
      if(this.$refs.form.validate()){
        this.submitStatus = true
        const [err, ] = await apiChat.send(data)
        this.submitStatus = false 
      
        if(err) {
          this.$alert('',err,'warning') 
          return
        }     

        this.getChatApi()
        this.$refs.form.reset()  
        this.$refs.form.resetValidation()
      } 
    },
  } 
}
</script> 